import { QueryClient as TanstackQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { QueryClient } from 'react-query'

// https://tanstack.com/query/v5/docs/framework/react/guides/important-defaults
const queryConfigDefaults = {
	queries: {
		refetchOnWindowFocus: false,
		retry: 1,
		retryDelay: 3000,
		retryOnMount: false,
		// Set the stale time to 10 seconds. Prevents a query from refetching for every new instance of the query.
		staleTime: 10 * 1000,
	},
}

export const queryClient = new QueryClient({ defaultOptions: queryConfigDefaults })
export const tanstackQueryClient = new TanstackQueryClient({ defaultOptions: queryConfigDefaults })

declare module '@tanstack/react-query' {
	interface Register {
		defaultError: AxiosError<{ detail: string; status: number }>
	}
}
